import { ImageContentSectionV2 } from '../contentTypes';
import { getItemFromSwitch } from '../util';

export const stripHtml = (html?: string): string | undefined => {
  if (!html) {
    return undefined;
  }

  const text = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return text || undefined;
};

export const getImageUrlFromContentV2 = (image?: ImageContentSectionV2): string | undefined => {
  const provider = getItemFromSwitch(image?.provider);

  const url =
    provider?.bcom?.xxl?.url ??
    provider?.bcom?.xl?.url ??
    provider?.bcom?.lg?.url ??
    provider?.bcom?.md?.url ??
    provider?.bcom?.sm?.url ??
    provider?.bcom?.xs?.url ??
    provider?.thron?.xxl?.url ??
    provider?.thron?.xl?.url ??
    provider?.thron?.lg?.url ??
    provider?.thron?.md?.url ??
    provider?.thron?.xs?.url;

  return url?.replace(/\u200B/g, '');
};
